import React from 'react';
import ModernOpportunities from '../components/ModernOpportunities';

// Neutral cover for deals without a photo (also used by OpportunityReviewPage).
export function OpportunityBannerFallback({ name }) {
  return (
    <div className="w-full h-full flex items-center justify-center" style={{ backgroundColor: 'var(--color-primary, #1a2332)' }}>
      <span className="text-3xl font-bold text-white/25 px-6 text-center" style={{ fontFamily: 'Playfair Display, serif' }}>
        {(name || '?').split(' ').slice(0, 2).join(' ')}
      </span>
    </div>
  );
}

// /opportunities — one expanded listing for every brand (s153): the «Moderno»
// Photo Cards page approved in s141, skinned per theme (lib/opportunitySkin).
export default function OpportunitiesDirectoryPage() {
  return <ModernOpportunities />;
}
